import React from "react";
import "./style.css";
const FooterNav = () => {
  return (
    <nav>
      <div className="footer-menue">
        <ul>
         
         
          <li>
            <a href="#home">Back to Top</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default FooterNav;
